module.exports = __webpack_public_path__ + "media/images/openweather/mapicons/nl-4a684c7ec49e869165b761c2fb5eeca0.png";